import { Length, Matches, type ValidationArguments } from 'class-validator';
import _ from 'lodash-es';

import {
  ERROR_MESSAGE,
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  REGEX_HAS_CONTINUOUS_LETTERS,
} from './constants';
import {
  ContainsTwoOrMoreTypes,
  ContainsTwoOrMoreTypesConstraintConstraint,
  IsEqual,
  Trim,
} from './decorator';

class PasswordValidator {
  @Trim()
  @ContainsTwoOrMoreTypes({
    message: (args: ValidationArguments) => {
      if (
        ContainsTwoOrMoreTypesConstraintConstraint.isInvalidPasswordLanguage(
          _.isNil(args.value) ? '' : `${args.value}`,
        )
      ) {
        return ERROR_MESSAGE.INVALID_PASSWORD_LANGUAGE();
      }

      return ERROR_MESSAGE.INVALID_PASSWORD();
    },
  })
  @Matches(RegExp(REGEX_HAS_CONTINUOUS_LETTERS), {
    message: ERROR_MESSAGE.CONTINUOUS_LETTERS,
  })
  @Length(PASSWORD_MIN_LENGTH, PASSWORD_MAX_LENGTH, {
    message: ERROR_MESSAGE.WRONG_PASSWORD_LENGTH(PASSWORD_MIN_LENGTH, PASSWORD_MAX_LENGTH),
  })
  password: string;

  @IsEqual('password', { message: ERROR_MESSAGE.UNCONFIRMED_PASSWORD() })
  passwordConfirm: string;
}

export default PasswordValidator;
